import { getItemLangByItemId } from '../api';
import { normalizeLangLabel } from './itemLocaleDisplay';

function langRowDedupeKey(r) {
  return normalizeLangLabel(r?.lang);
}

function langRowRichness(r) {
  return (
    String(r?.langTitle ?? '').trim().length * 10000 +
    String(r?.langDefinition ?? '').trim().length * 100 +
    String(r?.langKeyword ?? '').trim().length
  );
}

/** Aynı dil etiketi için daha dolu satırı tut (boş kabuk + itemLang dolu yanıtı birleştirme). */
export function mergeLangArrays(existing, incoming) {
  const map = new Map();
  const put = (row) => {
    const k = langRowDedupeKey(row);
    if (!k) return;
    const prev = map.get(k);
    if (!prev || langRowRichness(row) > langRowRichness(prev)) {
      map.set(k, row);
    }
  };
  for (const row of Array.isArray(existing) ? existing : []) put(row);
  for (const row of incoming || []) put(row);
  return [...map.values()];
}

/**
 * Çok sayıda itemLang isteğini sınırlı eşzamanlılıkla çalıştırır (race-free sıra).
 * @param {number[]} ids
 * @param {number} [concurrency]
 */
export async function fetchItemLangMapsByIds(ids, concurrency = 12) {
  const uniqueIds = [...new Set(ids.filter((id) => id != null).map(Number))];
  const map = new Map();
  let cursor = 0;
  async function worker() {
    for (;;) {
      const i = cursor++;
      if (i >= uniqueIds.length) break;
      const itemId = uniqueIds[i];
      try {
        const res = await getItemLangByItemId(itemId);
        if (res?.status && Array.isArray(res.data) && res.data.length > 0) {
          map.set(itemId, res.data);
        }
      } catch (_) {
        /* tek madde hatası diğerlerini engellemesin */
      }
    }
  }
  const pool = Math.min(concurrency, Math.max(1, uniqueIds.length));
  await Promise.all(Array.from({ length: pool }, () => worker()));
  return map;
}
